import { createSlice } from '@reduxjs/toolkit';

const requiredSlice = createSlice({
  name: 'lead',
  initialState: {
    loading: false,
    leadData: null, // For create lead response
    leadList: [], // For get-all-leads response
    error: null,
    message: null,
    total: 0,
    // for jeweller -> followup flow
    leadByJeweller: null,      // result of "does this jeweller already have a lead"
    leadByJewellerLoading: false,
    createdLeadId: null,      // set once a lead is created from the jeweller flow
  },
  reducers: {
    // --- CREATE LEAD ---
    createLeadRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createLeadSuccess: (state, action) => {
      state.loading = false;
      state.leadData = action.payload.data || action.payload;
      state.message = action.payload.message || null;
      state.createdLeadId = action.payload?.data?._id || null;
    },
    createLeadFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    resetCreatedLeadId: (state) => {
      state.createdLeadId = null;
    },

    // --- GET ALL LEADS ---
    getAllLeadsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAllLeadsSuccess: (state, action) => {
      state.loading = false;
      // API shape: { success, statusCode, message, data: { data, total, page, limit } }
      state.leadList = action.payload?.data?.data || [];
      state.total = action.payload?.data?.total || 0;
      state.message = action.payload?.message || null;
    },
    getAllLeadsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateLeadRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.success = null;
    },
    updateLeadSuccess: (state, action) => {
      state.loading = false;
      state.lead = action.payload;
      state.success = 'Lead updated successfully!';
    },
    updateLeadFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    getLeadByJewellerRequest: (state) => {
      state.leadByJewellerLoading = true;
    },
    getLeadByJewellerSuccess: (state, action) => {
      state.leadByJewellerLoading = false;
      state.leadByJeweller = action.payload?.data || null;
    },
    getLeadByJewellerFailure: (state, action) => {
      state.leadByJewellerLoading = false;
      state.error = action.payload;
    },
    resetLeadByJeweller: (state) => {
      state.leadByJeweller = null;
      state.leadByJewellerLoading = false;
    },
  },
});

export const {
  createLeadRequest,
  createLeadSuccess,
  createLeadFailure,
  resetCreatedLeadId,
  getAllLeadsRequest,
  getAllLeadsSuccess,
  getAllLeadsFailure,
  updateLeadRequest,
  updateLeadSuccess,
  updateLeadFailure,
  getLeadByJewellerRequest,
  getLeadByJewellerSuccess,
  getLeadByJewellerFailure,
  resetLeadByJeweller,
} = requiredSlice.actions;

export default requiredSlice.reducer;
